import _util from '../../utils/';


const interviewManagementService = {
	selectInterviewManagement(gets, resolve, reject) {
		_util.request({
			url: '/api/HROffersAuditionArrange/Get',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	selectInterviewManagementDetail(gets, resolve, reject) {
		_util.request({
			url: '/api/HROffersAuditionArrange/InterviewReply',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	replyInterviewManagementDetail(data, resolve, reject) {
		_util.request({
			url: '//api/HROffersAuditionArrange/PutSuggest',
			method: "put",
			data: data,
			success: resolve,
			error: reject
		})
	},
	exportInterviewManagement(gets, resolve, reject) {
		_util.request({
			url: '/api/HROffersAuditionArrange/Export',
			params: gets,
			success: resolve,
			error: reject
		})
	}
};


export default interviewManagementService;


// WEBPACK FOOTER //
// ./src/services/Recruitment/interview-management-service.js